import {
  BIG_PLAY_BUTTON,
  CARD,
  CardDefinition,
  IMAGE,
  ImageDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  LayoutListDefinition,
  TAB,
  TabDefinition,
  TABS,
  TEXT,
  VIDEO,
  VideoDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { isIOS, isSafari } from 'react-device-detect';
import type { TabItem } from '~/training/sequence/templates/items/tab/types';

export const Interactive2: Translator = sequence => {
  const root = translate(sequence, () => null);
  const tabs: TabDefinition[] = [];
  let iterator = 0;
  const tabsTitles: string[] = [];

  sequence.items?.forEach(item => {
    const tabItem = item as TabItem;

    if (tabItem.__typename == 'Tab' || tabItem.typename == 'Tab') {
      tabsTitles.push(tabItem.title || '');

      const items: Array<
        | VideoDefinition
        | ImageDefinition
        | CardDefinition
        | LayoutListDefinition
      > = [];

      if (tabItem.videos && tabItem.videos.length) {
        items.push({
          id: `video_${tabItem.id}`,
          type: VIDEO,
          values: {
            isolated: true,
            mediaUrl:
              isIOS || isSafari
                ? ([
                    tabItem.videos[0].mediaUrl && {
                      src: tabItem.videos[0].mediaUrl,
                      type: 'video/mp4'
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ].filter(Boolean) as any)
                : ([
                    tabItem.videos[0].hlsUrl && {
                      src: tabItem.videos[0].hlsUrl,
                      type: 'application/vnd.apple.mpegurl'
                    },
                    tabItem.videos[0].mediaUrl && {
                      src: tabItem.videos[0].mediaUrl,
                      type: 'video/mp4'
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ].filter(Boolean) as any),
            subtitlesUrl:
              tabItem.videos && tabItem.videos.length
                ? tabItem.videos[0].subtitlesUrl
                : null,
            autoPlay: false,
            showProgress: true,
            showPlayButton: true,
            videoContainerStyles: {
              width: '300px',
              height: '500px',
              position: 'relative',
              borderRadius: '20px'
            }
          },
          items: []
        } as VideoDefinition);
      }

      if (tabItem.audios) {
        items.push({
          type: LAYOUT_LIST,
          id: `wrap_img_${item.id}`,
          values: { align: 'center', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: IMAGE,
              id: tabItem.id,
              items: [
                {
                  id: `${tabItem.id}_image_layout_list`,
                  type: LAYOUT_LIST,
                  values: {
                    align: 'center',
                    height: { _: 'auto', lg: '100%' }
                  },
                  items: [
                    {
                      type: BIG_PLAY_BUTTON,
                      id: `${tabItem.id}_audios`,
                      values: {
                        showProgress: true,
                        mediaUrl: tabItem.audios?.[0]?.mediaUrl,
                        subtitlesUrl: tabItem.audios?.[0]?.subtitlesUrl
                      },
                      items: []
                    }
                  ]
                }
              ],
              values: {
                url: tabItem.pictures?.[0].mediaUrl,
                alt: tabItem.pictures?.[0].name
              }
            } as ImageDefinition
          ]
        });
      } else {
        if (tabItem.pictures && tabItem.pictures.length) {
          items.push({
            type: LAYOUT_LIST,
            id: `wrap_img_${item.id}`,
            values: { align: 'center', height: { _: 'auto', lg: '100%' } },
            items: [
              {
                type: IMAGE,
                id: tabItem.id,
                items: [],
                values: {
                  url: tabItem.pictures?.[0].mediaUrl,
                  alt: tabItem.pictures?.[0].name
                }
              } as ImageDefinition
            ]
          });
        }
      }

      items.push({
        type: CARD,
        id: `card_${tabItem.id}`,
        values: {
          clearStyles: 'xs',
          height: '100%',
          width: '100%',
          padding: 0,
          borderRadius: 0
        },
        items: [
          {
            type: LAYOUT_LIST,
            id: `${sequence.id}.cardlist`,
            values: {
              orientation: 'column',
              align: {
                _: 'top left',
                md: 'left'
              }
            },
            items: [
              {
                type: TEXT,
                id: `${tabItem.id}_subtitle`,
                items: [],
                values: {
                  value: tabItem.subtitle,
                  variant: 'sub_heading',
                  icon: tabItem.icon
                }
              },
              {
                type: TEXT,
                id: `${tabItem.id}_body`,
                items: [],
                values: {
                  value: tabItem.body
                }
              }
            ]
          }
        ]
      });

      tabs.push({
        type: TAB,
        id: `tab_${tabItem.id}`,
        items: [
          {
            type: LAYOUT_COLUMNS,
            id: `LAYOUT_COLUMNS_${tabItem.id}`,
            values: {},
            items: items
          }
        ],
        values: {
          iterator,
          value: tabItem.title || ''
        }
      });

      iterator++;
    }
  });

  root.items.push({
    id: 'LAYOUT_LIST',
    type: LAYOUT_LIST,
    values: {
      align: 'center',
      position: 'relative'
    },
    items: [
      {
        type: TABS,
        id: 'TABS',
        values: {
          tabsTitles
        },
        items: tabs
      }
    ]
  });

  return root;
};
